import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axios';
import toast from 'react-hot-toast';

const OpeningBalanceModal = ({ isOpen, onClose, company, onSuccess }) => {
    const [balance, setBalance] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && company) {
            // If company has existing opening balance (part of current_balance calculation), 
            // we might want to fetch it specifically or just start explicitly.
            // For now, start empty or 0.
            setBalance('');
        }
    }, [isOpen, company]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!company) return;

        const amount = parseFloat(balance);
        if (isNaN(amount)) {
            toast.error('נא להזין סכום תקין');
            return;
        }

        setLoading(true);
        try {
            await axiosInstance.put(`/api/admin/payments/companies/${company.company_id}/opening-balance`, {
                opening_balance: amount
            });

            toast.success('יתרת לפתיחה עודכנה בהצלחה');
            onSuccess();
            onClose();
        } catch (error) {
            toast.error(error.response?.data?.error || 'שגיאה בעדכון יתרת פתיחה');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

                {/* Background overlay */}
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-right overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                    <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                            <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div className="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right w-full">
                            <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                הגדרת חוב התחלתי (Opening Balance)
                            </h3>
                            <div className="mt-2">
                                <p className="text-sm text-gray-500 mb-4">
                                    הגדר את סכום החוב ההתחלתי עבור <strong>{company?.company_name}</strong>.
                                    <br />
                                    סכום זה יתווסף לחוב השוטף של החברה.
                                </p>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label htmlFor="balance" className="block text-sm font-medium text-gray-700 mb-1">
                                            סכום חוב התחלתי (₪)
                                        </label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            id="balance"
                                            value={balance}
                                            onChange={(e) => setBalance(e.target.value)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                            placeholder="0.00"
                                            required
                                        />
                                        <p className="text-xs text-gray-500 mt-1">
                                            ניתן להזין מספר שלילי עבור יתרת זכות.
                                        </p>
                                    </div>

                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:w-auto sm:text-sm disabled:opacity-50"
                                        >
                                            {loading ? 'שומר...' : 'שמור יתרה'}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={onClose}
                                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                        >
                                            ביטול
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeningBalanceModal;
